import { TEMP_ALL_USERS_PRO } from './app-config.js';

// Unconditional PRO Access: Every user currently receives full PRO status
// across all features (recording presets, themes, cloud sync, analytics).
export function hasProAccess(_user) {
  return true;
}

export function effectivePlan(_user) {
  return 'pro';
}
